/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { ReferenceProperty } from './reference-property';
export class LockObjectHistory {
  action: 0 | 1 | 2;
  actionInfo?: ActionInfo;
  id?: string;
  lockEndDate: string;
  lockStartDate: string;
  lockedBy: ReferenceProperty;
  lockedObject: ReferenceProperty;
}
